import { EnumTipoAdhesionCFlotante, EnumUnidadMedida } from '../../api'
import {
  FloatingConceptsModel,
  VirtualBatteryBalanceModel
} from '../../api/Argentia/endpoints/floatingConcepts/model/floatingConcepts'

import { DataTableColumn, FormDialogMode } from '@globaleris/ui.library'
import { DataTableActionConfiguration } from '../../model'

export default interface FloatingConceptsListItemViewModel {
  id: number
  subject?: FloatingConceptsSubjectViewModel
  contract?: FloatingConceptsConctractViewModel
  code?: string
  description?: string
  initDate: Date
  endDate?: Date
  amount: number
  unidadMedidaCantidad?: EnumUnidadMedida
  quantity?: number
  price?: number
  priceUnit: any
  floatingConceptType?: string
  tipoCalculoConcepto?: string
  adhesion?: EnumTipoAdhesionCFlotante
  masterConcept?: FloatingConceptsMasterConceptViewModel
  actionsConfiguration?: Array<DataTableActionConfiguration>
  actions?: any
  conceptDetail?: string
  commodity?: string
}

export interface FloatingConceptsConctractViewModel {
  id: number
  code: string
}

export interface FloatingConceptsSubjectViewModel {
  id?: number
  displayName?: string
}

export interface FloatingConceptsMasterConceptViewModel {
  id: number
  code?: string
}

export interface DialogConfiguration {
  title?: string
  formDialogMode?: FormDialogMode
  data?: any
  formSelected: DataTableColumn[]
}

export interface FloatingConceptsFetchFilter {
  startDate?: Date
  endDate?: Date
  subjectId?: number
  contractId?: number
  conceptCode?: string
  contractNotNull?: boolean
}
export enum EnumFloatingConceptsTabs {
  distribucion,
  refacturacion,
  penalizacion,
  manual,
  virtualBattery,
  balanceActions
}

export interface VirtualBatteryBalanceTableModel extends VirtualBatteryBalanceModel {
  codeColumn: string
}

export interface FloatingConceptsFormAddModel extends Partial<FloatingConceptsModel> {
  contractId?: number
  contractCode?: string
  settlementGroupId?: number
}
